<mat-dialog-content>
	@if (group.getRawValue(); as groupValue) {
	<div class="flex flex-col gap-6 flex-auto">
		<mat-toolbar>
			<h4 class="my-0">
				{{
					(value ? 'workspace.timecontingent.updateCredits' : 'workspace.timecontingent.addCredits') | translate
				}}
			</h4>
			<div class="flex-auto"></div>
			<button
				mat-icon-button
				matDialogClose
				tabindex="-1"
			>
				<mat-icon>close</mat-icon>
			</button>
		</mat-toolbar>
		<form
			[formGroup]="group"
			class="px-6 pb-6"
		>
			<div
				(click)="$event.preventDefault(); openUserPicker()"
				[ngClass]="{ 'cursor-pointer': !group.controls.user.disabled }"
				class="flex w-full flex-col"
			>
				<mat-form-field
					appearance="fill"
					class="form-control-interactive"
				>
					<mat-label>{{ 'user.select' | translate }}</mat-label>
					<div
						*ngIf="groupValue.user as user"
						class="-mb-16px flex items-center space-x-1.5"
					>
						<app-user-avatar
							[userId]="user.id"
							class="rounded-full"
							size="40px"
						></app-user-avatar>
						<div class="flex flex-auto flex-col leading-none">
							<span>{{ user.name }}</span>
							<span class="mat-hint text-sm">{{ user.email }}</span>
						</div>
					</div>
					<input
						[disabled]="group.controls.user.disabled"
						[value]="groupValue.user"
						class="!pointer-events-none"
						matInput
						readonly
					>
				</mat-form-field>
			</div>
			<div
				(click)="$event.preventDefault(); group.controls.date.enabled && openCalPicker()"
				[ngClass]="{ 'cursor-pointer': group.controls.date.enabled }"
				class="flex w-full flex-col"
			>
				<mat-form-field
					appearance="fill"
					class="pointer-events-none"
				>
					<mat-label>{{ 'timer.date' | translate }}</mat-label>
					<input
						[disabled]="group.controls.date.disabled"
						[value]="groupValue.date | formatDate"
						class="!pointer-events-none"
						matInput
					>
				</mat-form-field>
			</div>
			<mat-form-field
				appearance="fill"
				fxFill
			>
				<mat-label>{{ 'Description' | translate }}</mat-label>
				<textarea
					cdkInitialFocus
					formControlName="description"
					matInput
					rows="5"
					type="text"
				></textarea>
				<mat-hint class="w-full text-right"
					>{{ groupValue.description?.length ?? 0 }}/ {{ maxLength }}</mat-hint
				>
			</mat-form-field>
			<div class="grid grid-cols-[1fr_100px] gap-2 items-baseline">
				<mat-form-field appearance="fill">
					<mat-label>{{ "comego.type" | translate }}</mat-label>
					<mat-select formControlName="type">
						<mat-option value="credit">{{ 'workspace.timecontingent.credit' | translate }}</mat-option>
						<mat-option value="deduct">{{ 'workspace.timecontingent.deduction' | translate }}</mat-option>
					</mat-select>
				</mat-form-field>
				<tg-duration-input-control
					[displayFormat]="false"
					formControlName="value"
					placeholder="00:00"
				>
					<ng-template
						durationInputControl
						let-control="control"
						let-disabled="disabled"
						let-inputPlaceholder="inputPlaceholder"
					>
						<mat-form-field
							[matTooltip]="inputPlaceholder | translate"
							[matTooltipDisabled]="disabled"
							appearance="fill"
							fxFill
						>
							<mat-label translate>utils.value</mat-label>
							<input
								[formControl]="control"
								matInput
								type="text"
							>
						</mat-form-field>
					</ng-template>
				</tg-duration-input-control>
			</div>
			<div class="flex items-end gap-2">
				<button
					mat-button
					matDialogClose
				>
					{{ 'utils.cancel' | translate }}
				</button>
				<button
					(click)="submit()"
					[disabled]="group.invalid || group.disabled"
					color="primary"
					mat-raised-button
					type="submit"
				>
					@if (value) { @switch (groupValue.type) { @case ('deduct') { {{ 'Update deduction' }}} @case
					('credit') { {{ 'Update credit' }}} } } @else { @switch (groupValue.type) { @case ('deduct') {
					{{ 'Apply deduction' }}} @case ('credit') { {{ 'Apply credit' }}} } }
				</button>
				@if (value) {
				<div class="flex-auto"></div>
				<button
					(click)="delete()"
					color="warn"
					mat-stroked-button
				>
					{{ 'utils.remove' | translate }}
				</button>
				}
			</div>
		</form>
	</div>
	}
</mat-dialog-content>
